<!--<div
  fxLayout="row"
  fxLayoutAlign="center"
  fxLayoutGap="gappx"
  class="color-white">
  <h3 [routerLink]="['/home']" class="cursorPointer" style="text-align: center;">iDBA</h3>
</div>-->

<div class="sidemenu">
  <div fxflex fxLayout="row" fxLayoutAlign="center" fxLayoutGap="gappx" class="logo-bkg">
    @if (logoi7Code) {
    <img [src]="logoi7Code" class="logo" />
    }
  </div>


  @if(menu.length > 0){
  <ng-material-multilevel-menu [configuration]="config" [items]="this.menu" (selectedItem)="selectedItem($event)">
  </ng-material-multilevel-menu>
  }

  <div class="sidemenu-footer" fxLayout="column" fxLayoutAlign="end center">
    @if (logoCliente) {
    <img [src]="logoCliente" class="bottom-img" />
    }

    @if (this.versao != 'undefined') {
    <div class="version">
      Versão: {{this.versao}}
    </div>
    }
  </div>
</div>